import { Routes } from '@angular/router';
import { AdminGuard } from '../infrastructure/auth/admin.guard';
import { FeatureFlagGuard } from '../infrastructure/auth/feature-flag.guard';
import { FEATURE_FLAG_KEYS } from '../infrastructure/domain/feature-flags';

export const AppLayoutRoutes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('../modules/dashboard/dashboard.module').then(m => m.DashboardModule),
  },

  {
    path: 'analytics',
    loadChildren: () => import('../modules/./analytics/analytics.module').then(m => m.AnalyticsModule),
    canActivate: [AdminGuard]
  },

  {
    path: 'notifications',
    children: [
      {
        path: 'admin',
        canActivate: [AdminGuard],
        loadChildren: () => import('../modules/notifications/notifications.module').then(m => m.NotificationsModule),
      },
      {
        path: '',
        loadChildren: () => import('../modules/notification-feed/notification-feed.module').then(m => m.NotificationFeedModule),
      }
    ]
  },

  {
    path: 'tasks',
    children: [
      {
        path: '',
        loadChildren: () => import('../modules/task/task.module').then(m => m.TaskModule),
      },
      {
        path: ':id',
        loadChildren: () => import('../modules/task/task.module').then(m => m.TaskModule),
      }
    ]
  },
  {
    path: 'projects',
    children: [
      {
        path: '',
        loadChildren: () => import('../modules/project/project.module').then(m => m.ProjectModule),
      },
      {
        path: 'legal-batch-import',
        loadChildren: () => import('../modules/project/project.module').then(m => m.ProjectModule),
      },
      {
        path: ':id',
        loadChildren: () => import('../modules/project/project.module').then(m => m.ProjectModule),
      }
    ]
  },
  {
    path: 'controladoria',
    canActivate: [FeatureFlagGuard],
    canMatch: [FeatureFlagGuard],
    data: {
      requiredFeatureFlagKey: FEATURE_FLAG_KEYS.LEGAL_CONTROL_QUEUE,
      featureFlagFallbackUrl: '/dashboard',
      featureFlagUnavailableMessage: 'Área de controladoria indisponível no momento.'
    },
    children: [
      {
        path: '',
        loadChildren: () => import('../modules/legal/control-queue/legal-control-queue.module').then(m => m.LegalControlQueueModule),
      }
    ]
  },
  {
    path: 'finance',
    children: [
      {
        path: '',
        loadChildren: () => import('../modules/finance/finance.module').then(m => m.FinanceModule),
      },
      {
        path: 'invoice',
        loadChildren: () => import('../modules/invoice/invoice.module').then(m => m.InvoiceModule)
      },
      {
        path: ':id',
        loadChildren: () => import('../modules/finance/finance.module').then(m => m.FinanceModule),
      }
    ]
  },
  {
    path: 'doc-generator',
    canActivate: [FeatureFlagGuard],
    canMatch: [FeatureFlagGuard],
    data: {
      requiredFeatureFlagKey: FEATURE_FLAG_KEYS.DOCUMENT_GENERATOR,
      featureFlagFallbackUrl: '/dashboard',
      featureFlagUnavailableMessage: 'Gerador de documentos indisponível no momento.'
    },
    children: [
      {
        path: '',
        loadChildren: () => import('../modules/document-generator/document-generator.module').then(m => m.DocumentGeneratorModule),
      }
    ]
  },
  {
    path: 'customers',
    children: [
      {
        path: '',
        loadChildren: () => import('../modules/customer/customer.module').then(m => m.CustomerModule),
      },
      {
        path: ':id',
        loadChildren: () => import('../modules/customer/customer.module').then(m => m.CustomerModule),
      }
    ]
  },
  {
    path: 'settings',
    children: [
      {
        path: 'feature-flags',
        canActivate: [AdminGuard],
        loadChildren: () => import('../modules/user-tenant-settings/user-tenant-settings/feature-flag-admin/feature-flag-admin.module').then(m => m.FeatureFlagAdminModule)
      },
      {
        path: '',
        loadChildren: () => import('../modules/user-tenant-settings/user-tenant-settings.module').then(m => m.UserTenantSettingsModule)
      },
      {
        path: 'ms_code',
        loadChildren: () => import('../modules/user-tenant-settings/user-tenant-settings.module').then(m => m.UserTenantSettingsModule)
      }
    ]
  },

  {
    path: 'invite/:id',
    loadChildren: () => import('../modules/user-tenant-settings/user-tenant-settings.module').then(m => m.UserTenantSettingsModule),

  },

  {
    path: 'user_settings',
    loadChildren: () => import('../modules/user-settings/user-settings.module').then(m => m.UserSettingsModule),
  },


  {
    path: 'windows/:path',
    children: [
      {
        path: '',
        loadChildren: () => import('../modules/window/window.module').then(m => m.WindowModule),
      },
      {
        path: ':detail/:id',
        loadChildren: () => import('../modules/window/window.module').then(m => m.WindowModule),
      }
    ]
  },
  {
    path: 'crud/:path',
    children: [
      {
        path: '',
        loadChildren: () => import('../modules/crud/crud.module').then(m => m.CrudModule),
      },
      {
        path: ':id',
        loadChildren: () => import('../modules/crud/crud.module').then(m => m.CrudModule),
      }
    ]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard'
  }
];
